import React, { useEffect } from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import SchoolDashboard from "../pages/SchoolDashboard";
import { auth } from "../firebase";

export const AdminViewSchool = () => {
  const { uid } = useParams();              // this is the school user’s uid (schoolId)
  const location = useLocation();
  const state = location.state || {};
  const { adminView } = state;

  const currentUser = auth.currentUser;

  // 🔑 Set the schoolId for dashboards that read it from localStorage
  useEffect(() => {
    if (uid) {
      localStorage.setItem("schoolId", uid);
    }
  }, [uid]);

  // Only after all hooks:
  if (!currentUser) {
    return <Navigate to="/admin-login" replace />;
  }

  return <SchoolDashboard adminView={!!adminView} />;
};
